@if (!!url) {
  <div class="iframe-container">
    <iframe [src]="url"></iframe>
  </div>
}
